import { useParams } from 'react-router-dom'
import { Hooks } from 'service-api'
import { useSessionContext } from '@providers/session'
import { PackageCreditsTableRow, RedeemedPackageCredits } from './types'
import { usePackageCredits } from 'hooks/usePackageCredits'
import { Link, Stack, Typography } from '@mui/material'
import { Link as NavLink } from 'react-router-dom'
import { PackageCreditsTable } from './package_credits_table'

const RedemptionDateCell = (date: string, row: PackageCreditsTableRow | RedeemedPackageCredits): React.ReactNode => {
  const { accountName: locationName = '' } = useParams()

  if ('orderId' in row) {
    return (
      <Typography variant="body2">
        <Link
          sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
          component={NavLink}
          color="inherit"
          to={`/${locationName}/account/bookings/${row.orderId}`}
        >
          {date}
        </Link>
      </Typography>
    )
  }

  return <Typography variant="body2">{date}</Typography>
}

export const PackageCredits = () => {
  const { accountName: locationName = '' } = useParams()
  const sessionCtx = useSessionContext()

  const { data: locationUserProfile } = Hooks.useClientLocationUserProfile(
    locationName,
    sessionCtx.state.user?.lupId || ''
  )
  const { available, redeemed, expired } = usePackageCredits({
    locationName,
    locationUserProfileId: locationUserProfile?.id || '',
    enabled: !!locationUserProfile?.id,
  })

  return (
    <Stack mt={2} gap={2}>
      {available?.length ? <PackageCreditsTable type="AVAILABLE" data={available || []} orderBy="expiredAt" /> : null}
      {redeemed?.length ? (
        <PackageCreditsTable
          type="REDEEMED"
          data={redeemed || []}
          renderCell={{ usedAt: RedemptionDateCell }}
          orderBy="usedAt"
          order="desc"
        />
      ) : null}
      {expired?.length ? <PackageCreditsTable type="EXPIRED" data={expired || []} orderBy="expiredAt" /> : null}
    </Stack>
  )
}
